import { Card } from 'react-bootstrap';

import FilterView from '../../../common/components/FilterView';
import { Outlet, useLocation } from 'react-router-dom';
import { toggleColumnSettingsDashboard } from '../slices/dashboardSlice';
import { RootState } from '../../template/store';
import dataTableBgImg from '../../../../assets/img/illustrations/cornerRight-1.png';
import { useSelector } from 'react-redux';

const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';

const DashboardRoot = () => {
  const location = useLocation();
  const dataLoading = useSelector(
    (state: RootState) => state.dashboard.dataLoading
  );
  const grids = useSelector(
    (state: RootState) => state.dataTable.registrationMasterGrid
  );
  // const data = useSelector((state: RootState) => state.instructionDashboard.data);
  const data = useSelector(
    (state: RootState) => state.dashboard.registrationDashboardList
  );

  const obldetails = useSelector(
    (state: RootState) => state.registrationDashboard.obldetails
  );

  return (
    <FilterView
      showColumnSettings
      toggleColumnSettings={toggleColumnSettingsDashboard}
      showExport
      columnSettingsPersistKey='@odex/maintable/v6'
      uniqueFilterKey='adminDashboard'
      dataLoading={dataLoading}
      //  configViews={grids?.find?.((g) => g?.gridId === 1)?.configGroup || []}
      configViews={
        grids?.find?.((g: any) => g?.gridName === 'REGISTRATION_DASHBOARD')
          ?.configGroup || []
      }
      dashboardName='REGISTRATION_DASHBOARD'
      data={data}
      showRightDiv={location.pathname === `${APP_PATH_PREFIX}/registrationmaster`}
      gridDef={grids}
    />
  );
};

export default DashboardRoot;
